import _ from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import styles from './popover.module.scss';
import { PopoverUtil } from './popover-utils';
export const Popover = ({ content, align, contentWidth, appendToBody = true, showAlignArrow = false, targetRef = null, isVisible = false, popperRef = null, enableScroll = false, onClickOutside = _.noop, bottomOffset, className = '', isPositionFixed = false, onEscape = _.noop, isReferenceVisible = false, onPointerEnter = _.noop, onPointerLeave = _.noop, onKeyDown = _.noop, contentContainerClassName = '', ...restProps }) => {
    const { renderPopoverContent } = PopoverUtil(targetRef, styles, {
        content,
        appendToBody,
        align,
        contentWidth,
        showAlignArrow,
        isVisible,
        popperRef,
        enableScroll,
        onClickOutside,
        bottomOffset,
        className,
        isPositionFixed,
        onEscape,
        isReferenceVisible,
        onPointerEnter,
        onPointerLeave,
        onKeyDown,
        contentContainerClassName,
        ...restProps,
    });
    return (React.createElement(React.Fragment, null, isVisible && appendToBody
        ? ReactDOM.createPortal(renderPopoverContent(), document.body)
        : renderPopoverContent()));
};
//# sourceMappingURL=popover.js.map